import Link from "@/modules/LinkPayment/pages/Index.vue";

export default [
  {
    path: "/link-pagamento-nuts/:uuid",
    component: Link,
  },
];
